import { FilterFieldDefinition, FilterFieldGroupDefinition } from '../models';

export function isFilterFieldGroup<T>(
  fieldOrGroup: FilterFieldDefinition<T> | FilterFieldGroupDefinition<T>,
): FilterFieldDefinition<T>[] {
  if (fieldOrGroup) {
    if ('groupFields' in fieldOrGroup) {
      return fieldOrGroup.groupFields;
    }

    return [fieldOrGroup];
  }
  
  return [];
}
